import {
  getColorFromTheme,
  generateDefaultColorTheme,
  getEchartColorFromTheme,
  getF2ColorFromTheme,
  parseF2Color,
  customColorAtIndex,
  getCurrentDashboardTheme,
  getChartConfigColorByKey,
  getDataZoomColor,
  getThemeByKey,
} from '@constants/echart'
import { RESERVE_OPTION_MAPS } from '../../utils/incOptions'
import { formatDisplay, specialFormatDisplay, generateReportRedirectUrl, chartReportRedirect, toJustifyDecimalFixed } from './generateDisplayFormat'
import { scaleChart, getEchartRenderer, getTooltipScale } from './echartOptionHelper'
import { pluckDimsData, pluckNumsData, pluckZaxisData, pluckComparisonData, pluckColumnData } from './dataConverter'
import {
  getCustomFieldConfig,
  getCustomScopeConfig,
  getCustomConfigData,
  getMergedCustomConfigData,
  getPropComponentByField,
  concatCommonConfig,
  getFieldValByStrKeys
} from '../../utils/propConfigHelper'
import getChartIcon from './getChartIcon'

import fmtSeries from './fmtSeries'
import fmtNumber from './fmtNumber'
import markLine from './markLine'
import cellsConfigEffected from './cellsConfigEffected'
import isIE from './isIE'
import showMessageBox from '@components/showMessageBox'
import getTotal from './getTotal'
import { toFixed } from '@helpers/numberUtils'

export default {
  OPERATE_OPTION_RESERVE_MAPS: RESERVE_OPTION_MAPS,
  applyOptionMarkline: markLine,
  Theme: {
    getColorFromTheme,
    generateDefaultColorTheme,
    getEchartColorFromTheme,
    getF2ColorFromTheme,
    customColorAtIndex,
    parseF2Color,
    // 获取当前报告配置的主题
    getCurrentDashboardTheme,
    // 根据key获取单图中需要的默认颜色
    getChartConfigColorByKey,
    getDataZoomColor,
    getThemeByKey,
  },
  DataUtils: {
    pluckDimsData,
    pluckNumsData,
    pluckZaxisData,
    pluckComparisonData,
    fmtNumber,
    noValueFormatter: fmtSeries,
    pluckColumnData,
    toFixed,
    toJustifyDecimalFixed,
  },
  chartConfigUtils: {
    getCustomFieldConfig,
    getCustomScopeConfig,
    getCustomConfigData,
    getMergedCustomConfigData,
    getPropComponentByField,
    concatCommonConfig,
    getFieldValByStrKeys
  },
  cellsConfigEffected,
  formatDisplay,
  specialFormatDisplay,
  generateReportRedirectUrl, //生成报告跳转的URL
  chartReportRedirect,       //报告跳转调用
  scaleChart,
  getEchartRenderer,
  getTooltipScale,
  getChartIcon,                 // 根据chartCode取得组件图标
  isIE,
  showMessageBox,             // 移动端数值备注&标题备注提示弹窗
  getTotal, // tooltips 总计
}
